import {Component, Input, OnInit} from '@angular/core';
import {ColumnData, ColumnFieldComponent} from "../../../../core/components/table/Column";

@Component({
  selector: 'app-icons-structure-single',
  templateUrl: './icons-structure-single.component.html',
  styleUrls: ['./icons-structure-single.component.scss']
})
export class IconsStructureSingleComponent implements ColumnFieldComponent, OnInit {

  @Input() field: string | undefined;

  // Display value: name del lookup (per Language e' gia' localizzato dal BE).
  @Input() fieldValue: string | undefined;

  // Chiave stabile usata SOLO per costruire il path SVG. Per Language usa
  // englishName perche' name varia con la lingua. Per altri lookup coincide con name.
  imageKey: string | undefined;

  // Path dell'icona, o null quando non c'e' una chiave da cui costruirlo: in quel
  // caso la cella mostra solo il testo invece di chiedere `undefined.svg`.
  imagePath: string | null = null;

  // Impostato dall'(error) dell'<img>: un valore senza SVG corrispondente mostra
  // solo il testo invece del glifo di immagine rotta.
  iconMissing = false;


  data!: ColumnData;

  ngOnInit() {

    this.field = this.data.field?.field?.toString()?.slice(12, this.data.field?.field?.toString()?.length );

    const obj = this.data.row?.combination[''+this.field];
    this.fieldValue = obj?.name;

    if (this.field === 'language') {
      this.imageKey = obj?.englishName;
    } else {
      this.imageKey = this.fieldValue;
    }

    this.imagePath = this.imageKey ? `./assets/icons/${this.field}/${this.imageKey}.svg` : null;
  }

  onIconError() {
    this.iconMissing = true;
  }

}
